<template lang="html">
    <div class="row">
        <div class="col-12 grid-margin">
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title mb-4">Edit Category</h5>
                    <form class="forms-sample">
                        <b-form-group label="Category Name">
                            <b-form-input v-model="category.name"
                                          type="text" 
                                          placeholder="Name">
                            </b-form-input>
                        </b-form-group>
                        <b-form-group label="Description">
                            <b-form-textarea v-model="category.description" 
                                             :rows="3"
                                             :max-rows="6"
                                             placeholder="Description">
                            </b-form-textarea>
                        </b-form-group>
                        <b-button variant="success" 
                                  class="mr-2"
                                  v-on:click="handleBtnSave">
                                  Save
                        </b-button>
                        <b-button variant="light"
                                  v-on:click="handleBtnCancel">
                                  Cancel
                        </b-button>
                    </form>
                </div>
            </div>
        </div>      
    </div>
</template>

<script lang="js">
import { mapActions, mapGetters, mapMutations } from'vuex'
import CategoryBaseForm from './CategoryBaseForm'
export default{
  name: 'categoryeditfrom',
  extends: CategoryBaseForm,
  computed: {
      ...mapGetters([
          'categories/getCategoryById'
      ])
  },
  methods : {
      ...mapMutations({
          update : 'categories/update'
      })
  },
  created() {
      this.setAction('categories/updateCategoryAction');
      this.category = this.$store
                    .getters['categories/getCategoryById'](this.$route.params.id);
  }
}
</script> 